import { Tag } from "ant-design-vue";
import { conditionFormChecker, putField } from "../../../../utils/form";
import {
    createColumnBoolean,
    createColumnInput,
    createColumnTreeSelect
} from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import {
    createFieldCheckbox, createFieldInputNumber,
    createFieldSelect,
    createFieldTreeSelect
} from "../../../../components/input/template-builder/template-builder.logic";
import lodash from "lodash";

export const callDepartment = () => store.dispatch("resource/v1/master/department/cacheFindAllWithChildrenType", { type: "main" });

export const callRiskTopic = ({ searchQuery }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
    ];
    if (searchQuery) {
        where.push({ name: "nameS", type: "String", operator: "like", value: searchQuery });
    }
    return store
        .dispatch("resource/v1/master/riskTopic/search", {
            criteria: {
                select: ["**"],
                page: 0,
                size: 1000000,
                where,
                sort: [
                    { name: "nameS", type: "ASC" },
                ]
            }
        })
        .then(page => page.data);
};

export const createColumns = () => {
    const columns = [
        createColumnBoolean({ title: () => i18n.global.t("model.inspectionRisk.isDefault"), dataIndex: "isDefault" }),
        createColumnInput({ title: () => i18n.global.t("model.department.fullCode"), dataIndex: "refDepartment.fullCode", align: "center" }),
        createColumnTreeSelect({
            title: () => i18n.global.t("model.department.modelName"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({
                list: callDepartment,
                renderLabel: ({ item }) => (
                    <div>
                        {item.fullCode} : {item.nameTh}
                    </div>
                ),
                filterWhere: ({ value }) => [
                    { name: "fullCode", operator: "like", value },
                    { logic: "OR", name: "nameTh", operator: "like", value }
                ],
                treeDefaultExpandAll: true
            }),
            search: { name: "refDepartment.id" }
        }),
        createColumnBoolean({ title: () => i18n.global.t("model.inspectionRisk.isCheckCancelRelease"), dataIndex: "isCheckCancelRelease" }),
        createColumnBoolean({ title: () => i18n.global.t("model.inspectionRisk.isCheckRedAccount"), dataIndex: "isCheckRedAccount" }),
        createColumnBoolean({ title: () => i18n.global.t("model.inspectionRisk.isCheckGreenAccount"), dataIndex: "isCheckGreenAccount" }),
        createColumnInput({
            title: () => i18n.global.t("model.inspectionRisk.riskTopics"),
            customRender: ({ record }) => {
                const dom = record.riskTopics?.map(d=><div><Tag color="blue" class="mt-1 ml-2 text-14">{d.refRiskTopic?.nameS}</Tag></div>) || []
                return <>{...dom}</>
            },
            search: { visible: () => false }
        })
    ];
    return columns;
};

export const createField = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            // createFieldCheckbox({
            //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
            //     key: `${prefix}isDefault`,
            //     colProp: () => ({ xs: 24 }),
            //     formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            //     label: () => `${i18n.global.t("model.inspectionRisk.isDefault")}`,
            //     inputProp: ({ field }) =>
            //         lodash.merge(
            //             {
            //                 checked: model.isDefault,
            //                 'onUpdate:checked': checked => {
            //                     model.isDefault = checked;
            //                     model.refDepartment = null;
            //                 },
            //                 disabled: viewOnly
            //             },
            //             conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
            //         )
            // }),
            createFieldTreeSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refDepartment`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 12 } }),
                label: () => i18n.global.t("model.department.modelName"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refDepartment,
                            "onUpdate:value": value => (model.refDepartment = value),
                            disabled: viewOnly,
                            list: callDepartment,
                            renderLabel: ({ item }) => (
                                <div>
                                    {item.fullCode} : {item.nameTh}
                                </div>
                            ),
                            filterWhere: ({ value }) => [
                                { name: "fullCode", operator: "like", value },
                                { logic: "OR", name: "nameTh", operator: "like", value }
                            ],
                            treeDefaultExpandAll: true
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}isCheckCancelRelease`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.inspectionRisk.isCheckCancelRelease")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: model.isCheckCancelRelease,
                            "onUpdate:checked": checked => {
                                model.isCheckCancelRelease = checked;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}isCheckRedAccount`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.inspectionRisk.isCheckRedAccount")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: model.isCheckRedAccount,
                            "onUpdate:checked": checked => {
                                model.isCheckRedAccount = checked;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}riskTopics`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.inspectionRisk.riskTopics"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.riskTopics,
                            "onUpdate:value": value => (model.riskTopics = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) =>
                                callRiskTopic({ searchQuery }).then(items => items.map(item => ({ refRiskTopic: item, isSave: true }))),
                            mode: "multiple",
                            optKey: "refRiskTopic.id",
                            optLabel: "refRiskTopic.nameS",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}mediumInspectCount`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 16 }, wrapperCol: { xs: 24, md: 8 } }),
                label: () => i18n.global.t("model.inspectionRisk.mediumInspectCount"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.mediumInspectCount,
                            "onUpdate:value": value => (model.mediumInspectCount = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}mediumSkipCount`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 8 } }),
                label: () => i18n.global.t("model.inspectionRisk.mediumSkipCount"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.mediumSkipCount,
                            "onUpdate:value": value => (model.mediumSkipCount = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            }),
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}isCheckGreenAccount`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.inspectionRisk.isCheckGreenAccount")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: model.isCheckGreenAccount,
                            "onUpdate:checked": checked => {
                                model.isCheckGreenAccount = checked;
                            },
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lowInspectCount`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 16 }, wrapperCol: { xs: 24, md: 8 } }),
                label: () => i18n.global.t("model.inspectionRisk.lowInspectCount"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.lowInspectCount,
                            "onUpdate:value": value => (model.lowInspectCount = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lowSkipCount`,
                colProp: () => ({ xs: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 8 } }),
                label: () => i18n.global.t("model.inspectionRisk.lowSkipCount"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.lowSkipCount,
                            "onUpdate:value": value => (model.lowSkipCount = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                }
            }),
        ]
    });
};
